import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCity } from '../context/CityContext';
import '../styles/MoreDropdown.css';

const MoreDropdown = ({ onClose }) => {
  const { selectedCity } = useCity();
  const navigate = useNavigate();

  const handleServiceCarClick = () => {
    const formattedCity = selectedCity.toLowerCase().replace(/\s+/g, '-');
    navigate(`/services/${formattedCity}`);
    onClose();
  };

  // 🔥 All items in ONE FLOW (Spinny style)
  const menuItems = [
    // 🔝 TOP SECTION
    { icon: '📋', label: 'About Us', path: '/about' },

    {
      icon: '💰',
      label: 'Finance your Car',
      sub: 'Instant loan with 0 downpayment',
      path: '/finance',
    },

    {
      icon: '🔧',
      label:'Service Car',
      sub: 'Book a trusted service',
      isButton: true,
      onClick: handleServiceCarClick,
    },

    { icon: '😊', label: 'How it Works', path: '/how-it-works' },
    { icon: '📍', label: 'Car Hub Locations', path: '/locations' },

    { divider: true }, // 🔥 Divider here

    // 🔽 BOTTOM SECTION
    { icon: '📝', label: 'Blog', path: '/blog' },
    { icon: '💬', label: 'Customer Reviews', path: '/reviews' },
    { icon: '🚗', label: 'Scrap Car', path: '/scrap-car' },

    {
      icon: '💵',
      label: 'Car Valuation',
      sub: 'Know your cars true worth',
      path: '/valuation',
    },

    { icon: '✅', label: 'Check eChallan', path: '/echallan' },
    {
      icon: '🧮',
      label: 'Service Cost Calculator',
      path: '/service-cost-calculator',
    },
  ];

  const renderItem = (item, idx) => {
    if (item.divider) {
      return <div key={idx} className="more-divider-line" />;
    }

    const content = (
      <div className="more-item">
        <span className="more-icon">{item.icon}</span>

        <div className="more-text">
          <span className="more-label">{item.label}</span>
          {item.sub && <span className="more-sub">{item.sub}</span>}
        </div>

        <span className="more-arrow">›</span>
      </div>
    );

    if (item.isButton) {
      return (
        <button key={idx} className="more-row" onClick={item.onClick}>
          {content}
        </button>
      );
    }

    return (
      <Link key={idx} to={item.path} className="more-row" onClick={onClose}>
        {content}
      </Link>
    );
  };

  return (
    <div className="more-dropdown-panel">
      <div className="more-accent-bar" />

      <div className="more-header">
        <span className="more-header-title">Explore More</span>
      </div>

      <div className="more-list">
        {menuItems.map((item, idx) => renderItem(item, idx))}
      </div>
    </div>
  );
};

export default MoreDropdown;